// ============================================================================
// BESPOKIAN Health - Medications (Coming Soon)
// Placeholder for medication category pages linked from footer
// ============================================================================

import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { Link, useParams } from '@tanstack/react-router';
import { Package, ArrowRight } from 'lucide-react';

const categoryTitles: Record<string, string> = {
  heart: 'Heart & Blood Pressure',
  diabetes: 'Diabetes & Metabolic',
  'mental-health': 'Mental Health',
};

export function MedicationsPage() {
  const { category } = useParams({ strict: false });
  const title = category ? categoryTitles[category] ?? 'Medications' : 'All Medications';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />

      <main className="flex-1">
        <section
          className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
          style={{
            backgroundImage: 'linear-gradient(rgba(0, 21, 58, 0.6), rgba(0, 21, 58, 0.85)), url("/images/chemistry-lab-hero.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
            <div className="w-16 h-16 bg-gold-500/20 rounded-2xl flex items-center justify-center mx-auto mb-8">
              <Package className="h-8 w-8 text-gold-400" aria-hidden />
            </div>
            <h1 className="text-4xl md:text-5xl font-serif text-white mb-4 tracking-tight">
              {title}
            </h1>
            <p className="text-xl text-navy-200 mb-2">
              Coming soon
            </p>
            <p className="text-navy-300 text-sm mb-10 max-w-md mx-auto">
              We’re building a clear view of medications and pricing by category. Check back soon or use Pricing to see transparent costs now.
            </p>
            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 bg-gold-500 text-navy-900 font-semibold px-6 py-3 rounded-lg hover:bg-gold-400 transition-colors"
            >
              View pricing
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
